import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    checkCanCreateTrigger: `${baseURL}/api/automation/cancreate`,
    getWorkflowsList: (idList, params) =>
      `${baseURL}/api/list/${encodeURI(idList)}/workflows?${encodeParams(
        params
      )}`,
    copyWorkflow: (idWorkflow) =>
      `${baseURL}/api/workflow/${encodeURI(idWorkflow)}/copy`,
    simulateWorkflow: (idWorkflow) =>
      `${baseURL}/api/workflow/${encodeURI(idWorkflow)}/simulate`,
    deleteWorkflow: (idWorkflow) =>
      `${baseURL}/api/workflow/${encodeURI(idWorkflow)}/delete`,
    setEnableWorkflow: (idWorkflow) =>
      `${baseURL}/api/workflow/${encodeURI(idWorkflow)}/enable/set`,
    getWorkflowDetails: (idWorkflow) =>
      `${baseURL}/api/workflow/${encodeURI(idWorkflow)}`,
    createWorkflow: `${baseURL}/api/workflow`,
    getConditionsdescription: (idWorkflow) =>
      `${baseURL}/api/workflow/${idWorkflow}/conditionsdescription`,

    // task
    getTask: (idTask) => `${baseURL}/api/task/${idTask}`,
    saveTask: (idTask) => `${baseURL}/api/task`,
    updateTask: (idTask) => `${baseURL}/api/task/${idTask}`,
    deleteTask: (idTask) => `${baseURL}/api/task/${encodeURI(idTask)}/delete`,
    hasTaskEverSent: (idTask) => `${baseURL}/api/task/${idTask}/haseversent`,
    getSearchUrl: (idList, params) =>
      `${baseURL}/api/tasks/list/${encodeURI(idList)}/search?${encodeParams(
        params
      )}`,
    setTaskEnable: (idTask, params) =>
      `${baseURL}/api/task/${encodeURI(idTask)}/enable/set?${encodeParams(
        params
      )}`,
    copyTask: (idTask) => `${baseURL}/api/task/${encodeURI(idTask)}/copy`,
    simulateTask: (idTask) =>
      `${baseURL}/api/task/${encodeURI(idTask)}/simulate`,
    getTaskExecutionStat: (idTask) =>
      `${baseURL}/api/task/${encodeURI(idTask)}/executionstats`,
    getLastExecutionForRecipient: (idTask, idRecipient) =>
      `${baseURL}/api/task/${encodeURI(idTask)}/recipient/${encodeURI(
        idRecipient
      )}/lastexecution`
  }
})(process.env.BEAUTOMATION_URL)

/**
 * @typedef {Object} CanCreateCheck
 * @property {boolean} Value
 *
 * @description Check if a console can create tasks or workflow
 * @return {CanCreateCheck}
 */
export const beAutomationApiCheckCanCreate = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.checkCanCreateTrigger
  }).then(extractApiData)
}

export const beAutomationApiSearchTasks = (idList, params, bodyParams) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSearchUrl(idList, params),
    data: JSON.stringify(bodyParams)
  }).then(({ data }) => {
    return data
  })
}

/**
 * @description
 * @param {*} data
 * @param {Object} params
 * @param {boolean} params.Enable
 */
export const beAutomationApiSetTaskEnable = (idTask, params) => {
  const url = endpoints.setTaskEnable(idTask)
  return apiWrapper({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then(({ data }) => data)
}

export const beAutomationApiCopyTrigger = (idTask) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.copyTask(idTask)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiSimulate = (idTask) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.simulateTask(idTask)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiDelete = (idTask) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteTask(idTask)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiGetWorkflowsList = (idList, params, bodyParams) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getWorkflowsList(idList, params),
    data: JSON.stringify(bodyParams)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiCopyWorkflow = (idWorkflow) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.copyWorkflow(idWorkflow)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiSimulateWorkflow = (idWorkflow) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.simulateWorkflow(idWorkflow)
  }).then(({ data }) => {
    return data
  })
}

export const beAutomationApiDeleteWorkflow = (idWorkflow) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteWorkflow(idWorkflow)
  }).then(({ data }) => {
    return data
  })
}

/**
 * @description
 * @param {*} data
 * @param {Object} params
 * @param {boolean} params.Enable
 */
export const beAutomationApiSetEnableWorkflow = (idWorkflow, params) => {
  const url = endpoints.setEnableWorkflow(idWorkflow)
  return apiWrapper({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then(({ data }) => data)
}

/**
 * @typedef {Object} WorkflowDetails
 *
 * @description Get workflow details
 * @param {int} idWorkflow
 * @return {WorkflowDetails}
 */
export const beAutomationApiGetWorkflowDetails = (idWorkflow) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getWorkflowDetails(idWorkflow)
  }).then(extractApiData)
}

/**
 * @typedef {Object} WorkflowDetails
 *
 * @description Update existing workflow
 * @param {int} idWorkflow
 * @param {Object} data
 * @return {WorkflowDetails}
 */
export const beAutomationApiUpdateWorkflowDetails = (idWorkflow, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.getWorkflowDetails(idWorkflow),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

/**
 * @typedef {Object} WorkflowDetails
 *
 * @description Create new workflow
 * @param {Object} data
 * @return {WorkflowDetails}
 */
export const beAutomationApiCreateWorkflowDetails = (data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.createWorkflow,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beAutomatioApiGetConditionsdescription = (idWorkflow, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getConditionsdescription(idWorkflow),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beAutomatioGetTask = (idTask) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getTask(idTask)
  }).then(extractApiData)
}

export const beAutomatioApiPostSaveTask = (data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.saveTask(),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beAutomatioApiPutUpdateTask = (idTask, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateTask(idTask),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beAutomationApiHasTaskEverSent = (idTask) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.hasTaskEverSent(idTask)
  }).then(extractApiData)
}

export const beAutomationApiGetExecutionStats = (idTask) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getTaskExecutionStat(idTask)
  }).then(extractApiData)
}

export const beAutomationApiGetLastExecutionForRecipient = (
  idTask,
  idRecipient
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getLastExecutionForRecipient(idTask, idRecipient)
  }).then(extractApiData)
}

export const WORKFLOW_MESSAGE_TYPE_EMAIL = 0
export const WORKFLOW_MESSAGE_TYPE_SMS = 1
export const WORKFLOW_STEP_ID_TYPE_WAIT = -1

export const TASK_MESSAGE_TYPE_EMAIL = 0
export const TASK_MESSAGE_TYPE_SMS = 1
